<template lang="pug">
    a.battles-banner(target="_blank" href="https://cleverstart.ru/new_year_2025")
        video.battles-banner__video(autoplay loop muted)
            source(src="videos/new_year_banner.mp4" type="video/mp4")
</template>

<script>
    export default {
        props: {
            userType: {
                type: Object,
                default: null,
            },
        },
        methods: {
            goTo() {
                this.$router.push({name: 'olympiads:register', params: {id: '26'}});
            },
        },
    };
</script>

<style lang="scss" scoped>
    .battles-banner {
        display: block;
        overflow: hidden;
        cursor: pointer;

        border-radius: $border-radius-20;
        background-color: $x-color-white;
    }
    .battles-banner__gif {
        width: 100%;
        outline: 2px solid $hsl-color-gray-98;
        outline-offset: -2px;
    }
    .battles-banner__video {
        width: 100%;
        outline: 2px solid $hsl-color-gray-98;
        outline-offset: -2px;
    }
</style>